import React from 'react'
import { Form, Input } from 'antd'
const FormItem = Form.Item;

const Password=Input.Password;
const InputComponent = ({ Name, Label, Rules, PlaceHolder, InitialValue, OnChange, OnPressEnter, OnBlur, Disabled, Style, ClassName, Size, MaxLength, MapsEnterToBlur, NoStyle,LabelCol,LabelAlign, WrapperCol}) => {

    const HandlePressEnter = (event) => {

        if (MapsEnterToBlur) {
            event.target.blur()
        } else {
            OnPressEnter(event)
        }
    }

    return (
        <FormItem
            name={Name}
            label={Label}
            rules={Rules}
            initialValue={InitialValue}
            noStyle={NoStyle}
            labelCol={LabelCol}
            wrapperCol={WrapperCol}
            labelAlign={LabelAlign}
            
           >
            <Password 
               onChange={OnChange}
                onPressEnter={HandlePressEnter}
                onBlur={OnBlur}
                placeholder={PlaceHolder}
                disabled={Disabled}
                style={Style}
                className={ClassName}
                size={Size}
                maxLength={MaxLength} />
        </FormItem>
    )
}
InputComponent.defaultProps = {
    Name: "Password",
    Label: "Contraseña",
    Rules: [
        {
            required: true,
            message: "El Campo es Requerido"
        }
    ],
    PlaceHolder: "",
    Style: {},
    ClassName: "",
    Size: "middle",
    InitialValue: "",
    OnChange: () => { },
    OnPressEnter: () => { },
    OnBlur: () => { },
    Disabled: false,
    MaxLength: undefined,
    MapsEnterToBlur: false,
    NoStyle: false,
    LabelCol:undefined,
    WrapperCol:undefined


}

export default InputComponent;
